
import {timeout, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DocumentGenerator } from '@app/models/automation/documentgenerator/documentgenerator.model';
import { DocumentGeneratorProcessRequestWrapper } from "@app/models/automation/documentgenerator/documentGeneratorProcessRequestWrapper.model";
import { UserService } from "@app/services/shared/user.service";
import { CloudDriveProvider } from "@app/models/clouddrive/clouddrive-provider.model";
import { CloudDriveService } from "@app/services/clouddrive/clouddrive.service";

@Injectable({ providedIn: 'root' })
export class DocumentGeneratorService {
  private service = 'api/DocumentGeneratorService';
  private isFileBeingStreamed: boolean = false;

  constructor(private httpClient: HttpClient,
    public cloudDriveService: CloudDriveService,
    public userService: UserService) {
    this.cloudDriveService.getUserProvider().subscribe(provider => {
      this.isFileBeingStreamed = provider === CloudDriveProvider.Cloud;
    });
  }

  public list(dnaClientId: number, deviceId: number): any {
    return this.httpClient.get(`${this.service}/list/${dnaClientId}/${deviceId}`);
  }

  public add(documentGenerator: DocumentGenerator): any {
    return this.httpClient.post(`${this.service}/add`, documentGenerator);
  }

  public update(documentGenerator: DocumentGenerator): any {
    return this.httpClient.put(`${this.service}/update`, documentGenerator);
  }

  public createDocumentPreview(id: number): any {
    return this.httpClient.get(`${this.service}/createDocumentPreview/${id}`);
  }

  public delete(id: number): any {
    return this.httpClient.delete(`${this.service}/delete/${id}`);
  }

  public analyze(dnaClientId: number, fileNames: string[]): any {
    let data = { dnaClientId, fileNames };
    return this.httpClient.post(`${this.service}/analyze`, data);
  }

  public process(wrapper: DocumentGeneratorProcessRequestWrapper): any {
    if (this.isFileBeingStreamed)
      return this.processAndReturnFile(wrapper);
    else
      return this.processAndReturnSuccessMessage(wrapper);
  }

  private processAndReturnFile(wrapper: DocumentGeneratorProcessRequestWrapper) {
    return this.httpClient.post(`${this.service}/process`, wrapper, {
      responseType: "blob",
      observe: "response"
    }).pipe(map(res => ({
      content: res != null ? res.body : null,
      fileName: res != null
        ? res.headers.get("content-disposition").split(';')[1].trim().split('=')[1].replace(/"/g, "")
        : ''
    })));
  }

  private processAndReturnSuccessMessage(wrapper: DocumentGeneratorProcessRequestWrapper) {
    return this.httpClient.post(`${this.service}/process`,
      wrapper, { responseType: "json", observe: "response" }).pipe(timeout(1500000));
  }

  canUserManageTemplates(dnaClientId: number) {
    return this.httpClient.get<boolean>(`${this.service}/canUserManageTemplates/${dnaClientId}`);
  }
}
